const EARTH_RADIUS_KM = 6371;

const toRadians = (degrees) => (degrees * Math.PI) / 180;

export const distanceInKm = (origin, destination) => {
  const latitudeDelta = toRadians(destination.latitude - origin.latitude);
  const longitudeDelta = toRadians(destination.longitude - origin.longitude);
  const originLatitude = toRadians(origin.latitude);
  const destinationLatitude = toRadians(destination.latitude);

  const haversine =
    Math.sin(latitudeDelta / 2) ** 2 +
    Math.cos(originLatitude) *
      Math.cos(destinationLatitude) *
      Math.sin(longitudeDelta / 2) ** 2;

  return 2 * EARTH_RADIUS_KM * Math.asin(Math.sqrt(haversine));
};

export const getPostcodesWithinRadius = (
  postalData,
  latitude,
  longitude,
  radiusKm = 10,
) => {
  const origin = {latitude: Number(latitude), longitude: Number(longitude)};
  if (
    !Number.isFinite(origin.latitude) ||
    !Number.isFinite(origin.longitude) ||
    !Array.isArray(postalData)
  ) {
    return [];
  }

  const postcodes = new Set();
  postalData.forEach((entry) => {
    const destination = {
      latitude: Number(entry?.coordonnees_gps?.lat),
      longitude: Number(entry?.coordonnees_gps?.lon),
    };
    const postcode = String(entry?.code_postal || "").trim();

    if (
      postcode &&
      Number.isFinite(destination.latitude) &&
      Number.isFinite(destination.longitude) &&
      distanceInKm(origin, destination) <= radiusKm
    ) {
      postcodes.add(postcode);
    }
  });

  return Array.from(postcodes).sort();
};
